import styled from 'styled-components';

export const Container = styled.div`
  background: ${(props) => props.theme.background};
  border-radius: 8px;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1);
  padding: 15px;
`;

export const Row = styled.div`
  display: flex;
  margin-top: 15px;
  align-items: flex-start;
`;

export const Icon = styled.div`
  width: 30px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
